export var BaseButtonSize;
(function (BaseButtonSize) {
    BaseButtonSize["SMALL"] = "small";
    BaseButtonSize["MEDIUM"] = "medium";
    BaseButtonSize["BIG"] = "big";
})(BaseButtonSize || (BaseButtonSize = {}));
export var BaseButtonType;
(function (BaseButtonType) {
    BaseButtonType["STANDARD"] = "standard";
    BaseButtonType["INVERTED"] = "inverted";
    BaseButtonType["PLAIN"] = "plain";
    BaseButtonType["DISABLED"] = "disabled";
})(BaseButtonType || (BaseButtonType = {}));
//# sourceMappingURL=Button.enum.js.map